import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { LoginScreen } from './screens/LoginScreen';
import { ShellLayout } from './screens/ShellLayout';
import { DashboardScreen } from './screens/DashboardScreen';
import { CreatorsListScreen } from './screens/CreatorsListScreen';
import { CreatorDetailScreen } from './screens/CreatorDetailScreen';
import { CodeRequestsScreen } from './screens/CodeRequestsScreen';
import { FeatureRequestsScreen } from './screens/FeatureRequestsScreen';
import { SurveysScreen } from './screens/SurveysScreen';
import { PayoutsScreen } from './screens/PayoutsScreen';
import { ActivityScreen } from './screens/ActivityScreen';
import { AppVersionScreen } from './screens/AppVersionScreen';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<ShellLayout />}>
          <Route path="/" element={<DashboardScreen />} />
          <Route path="/creators" element={<CreatorsListScreen />} />
          <Route path="/creators/:id" element={<CreatorDetailScreen />} />
          <Route path="/codes" element={<CodeRequestsScreen />} />
          <Route path="/feature-requests" element={<FeatureRequestsScreen />} />
          <Route path="/surveys" element={<SurveysScreen />} />
          <Route path="/payouts" element={<PayoutsScreen />} />
          <Route path="/activity" element={<ActivityScreen />} />
          <Route path="/app-version" element={<AppVersionScreen />} />
        </Route>
      </Route>
    </Routes>
  );
}
